import Meta from '@/components/common/Meta'

import StorageUnitCostPage from '@/v2/components/pages/landing-pages/storage-unit-cost-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-unit-cost-page'

interface StorageUnitCostPageProps {}

const Page: React.FC<StorageUnitCostPageProps> = () => {
  return (
    <>
      <Meta
        title={LANDING_PAGES_META_CONTENTS.storage_unit_cost.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''}
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_unit_cost?.keywords ?? LANDING_PAGES_META_CONTENTS.default?.keywords ?? ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_unit_cost?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageUnitCostPage />
    </>
  )
}

export default Page
